import { render, staticRenderFns } from "./Godfather.vue?vue&type=template&id=257b355e&scoped=true"
import script from "./Godfather.vue?vue&type=script&lang=js"
export * from "./Godfather.vue?vue&type=script&lang=js"
import style0 from "./Godfather.vue?vue&type=style&index=0&id=257b355e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257b355e",
  null
  
)

export default component.exports